import * as React from 'react';
export const caretRightSvg = React.forwardRef(function caretRightSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.86 7.186 6.582 4.13A1 1 0 0 0 5 4.943v6.114a1 1 0 0 0 1.581.813l4.28-3.056a1 1 0 0 0 0-1.628Z',
    }),
  );
});
caretRightSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var caretRight = {
  category: 'icon',
  colorable: true,
  name: 'caretRight',
  svg: caretRightSvg,
};
